import React from "react";
import { PageHeader } from "@/components/PageHeader";
import { MessageSquare, PackageCheck, Ban, Handshake, Lock, Flag } from "lucide-react";

const SECTIONS = [
  { icon: MessageSquare, title: "Safe communication", text: "Keep all conversations inside Pack Mate until a connection is established. Never share financial details, passwords, or one-time codes in chat." },
  { icon: PackageCheck, title: "Package inspection", text: "Always inspect a package before agreeing to carry it. Only accept items you can clearly see and that match the description provided." },
  { icon: Ban, title: "Prohibited items", text: "Never send or carry drugs, weapons, cash, hazardous, counterfeit, or otherwise illegal items. Requests containing prohibited items are blocked automatically." },
  { icon: Handshake, title: "Meeting & hand-over", text: "Meet in busy, public, well-lit places for pickup and drop-off. Bring a friend where possible and trust your instincts." },
  { icon: Lock, title: "Account security", text: "Use a strong, unique password and never reuse it elsewhere. Sign out on shared devices and review your active sessions." },
  { icon: Flag, title: "Reporting suspicious activity", text: "If something feels wrong, use the Report option on a delivery, user, or message. Reports are reviewed by our team." },
];

export default function Safety() {
  return (
    <div className="max-w-3xl mx-auto">
      <PageHeader title="Safety Center" subtitle="Tips to help you use Pack Mate more safely." />
      <div className="rounded-2xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-800 mb-6" data-testid="safety-disclaimer">
        Pack Mate connects people but cannot guarantee the conduct of other users or the safety of any exchange. Always use your own judgement.
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-testid="safety-sections">
        {SECTIONS.map((s) => (
          <div key={s.title} className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
            <div className="w-11 h-11 rounded-2xl bg-accent flex items-center justify-center"><s.icon className="w-5 h-5 text-primary" /></div>
            <h3 className="mt-3 font-semibold text-slate-900">{s.title}</h3>
            <p className="mt-1.5 text-sm text-slate-500 leading-relaxed">{s.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
